
/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Component: `.carousel` and `.carousel-sm`
 * difference being that `.carousel-sm` only
 * works on small (mobile) screens
 *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

export default function() {

	const $html = document.querySelector('html')
	const $heroCarousel = document.querySelector('.hero-carousel')
	const resizeEnd = _.debounce(() => {
		$html.classList.remove('frozen-carousels')
	}, 250)
	window.addEventListener('resize', () => {
		if (!$html.classList.contains('frozen-carousels')) {
			$html.classList.add('frozen-carousels')
		}
		resizeEnd()
	})

	_.each(document.querySelectorAll('.carousel, .carousel-sm'), $carousel => {
		const $gutter = $carousel.querySelector('.gutter')
		let $$slides
		const siema = new Siema({
			selector: $gutter,
			loop: true,
			onInit: () => {
				// dress up some of this carousel HTML with class names
				$$slides = $gutter.querySelectorAll('[style*="float:"]')
				const slidesLength = $$slides.length
				$$slides[0].parentElement.classList.add('track')
				_.each($$slides, $slide => $slide.classList.add('slide'))
				setTimeout(() => $$slides[0].classList.add('on'), 0)

				// add indices by number of slides
				const $indices = $carousel.querySelector('.carousel-indices')
				let indicesHtml = ''
				_.each($$slides, ($slide, index) => {
					indicesHtml += `<a href="#"${index === 0 ? ' class="on"' : ''}>`
					indicesHtml += '<div class="dot"><div class="ghost">'
					indicesHtml += `Carousel slide ${index}</div></div></a>`
				})
				$indices.innerHTML = indicesHtml

				// navigation event handlers
				$carousel.querySelector('.prev').addEventListener('click', event => {
					selectSlide(event, siema.currentSlide === 0 ? slidesLength - 1 : siema.currentSlide - 1)
				})
				$carousel.querySelector('.next').addEventListener('click', event => {
					selectSlide(event, siema.currentSlide + 1 === slidesLength ? 0 : siema.currentSlide + 1)
				})
				_.each($carousel.querySelectorAll('.carousel-indices a'), ($index, index) => {
					$index.addEventListener('click', event => selectSlide(event, index))
				})

				if ($heroCarousel) {
					setTimeout(() => {
						$$slides[siema.currentSlide].classList.add('cease-transitions')
					}, 1300)
				}
			},
			onChange: () => {
				selectSlide({ preventDefault: () => {} }, siema.currentSlide)
				if ($heroCarousel) {
					setTimeout(() => {
						$$slides[siema.currentSlide].classList.add('cease-transitions')
					}, 1300)
				}
			},
		})
		// event handler helper
		function selectSlide(event, index) {
			event.preventDefault()
			$carousel.querySelector('.carousel-indices .on').classList.remove('on')
			$carousel.querySelector(`.carousel-indices a:nth-child(${index + 1})`).classList.add('on')
			$carousel.querySelector('.slide.on').classList.remove('on')
			$carousel.querySelector(`.slide:nth-child(${index + 1})`).classList.add('on')
			siema.goTo(index)
		}
	})
}
